var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5493 20.5C10.7693 20.5 9.02923 19.9722 7.54919 18.9832C6.06915 17.9943 4.91559 16.5887 4.2344 14.9442C3.55322 13.2996 3.37499 11.49 3.72225 9.74419C4.06952 7.99836 4.92669 6.39471 6.18536 5.13604C7.44403 3.87737 9.04768 3.0202 10.7935 2.67294C12.5393 2.32567 14.3489 2.5039 15.9935 3.18509C17.638 3.86628 19.0436 5.01983 20.0325 6.49987C21.0215 7.97991 21.5493 9.71997 21.5493 11.5C21.5493 13.887 20.6011 16.1761 18.9133 17.864C17.2255 19.5518 14.9363 20.5 12.5493 20.5ZM12.5493 3.78572C11.0236 3.78572 9.5321 4.23815 8.26349 5.08581C6.99488 5.93347 6.00613 7.13827 5.42225 8.54787C4.83837 9.95747 4.6856 11.5086 4.98326 13.005C5.28092 14.5014 6.01563 15.876 7.0945 16.9548C8.17336 18.0337 9.54791 18.7684 11.0443 19.0661C12.5408 19.3637 14.0918 19.2109 15.5014 18.6271C16.911 18.0432 18.1159 17.0544 18.9635 15.7858C19.8112 14.5172 20.2636 13.0257 20.2636 11.5C20.2636 9.45405 19.4508 7.49189 18.0041 6.04518C16.5574 4.59847 14.5953 3.78572 12.5493 3.78572Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 15.3572L11.9062 11.7636V5.71429H13.192V11.23L16.4062 14.4507L15.4998 15.3572Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon3);
export default __webpack_public_path__ + "static/media/listicon3.d75cceaaa3bb235c7fe498fc5ecc5855.svg";
export { ForwardRef as ReactComponent };